import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStreamSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewStreamSharp.js
// module id = 7123
// module chunks = 2